/**
 * Same breakpoints the site used before (src/theme/breakpoints.js).
 * Panda is mobile-first: use `mdDown` etc. for the old desktop-first `md:` max-width styles.
 */
export const breakpoints = {
  xs: '420px',
  sm: '640px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  '2xl': '1536px',
};
